import React from "react";
import styles from "./Events.module.css";
import BannerHeader from "../../components/BannerHeader/BannerHeader";
import { FiMapPin } from "react-icons/fi";
import { EVENTS } from "../../constants/constants.js";

function formatDateRange(range) {
  const start = new Date(range.start);
  const end = new Date(range.end);
  const sameMonth = start.getMonth() === end.getMonth();
  const sameYear = start.getFullYear() === end.getFullYear();
  const startDay = start.getDate();
  const endDay = end.getDate();
  const month = start.toLocaleString("default", { month: "short" });
  const endMonth = end.toLocaleString("default", { month: "short" });
  const year = start.getFullYear();
  if (sameMonth && sameYear) {
    return `${startDay}-${endDay} ${month} ${year}`;
  } else if (sameYear) {
    return `${startDay} ${month} - ${endDay} ${endMonth} ${year}`;
  } else {
    return `${startDay} ${month} ${year} - ${endDay} ${endMonth} ${end.getFullYear()}`;
  }
}

const Events = () => {
  return (
    <div className={styles.mainContainer}>
      <BannerHeader />
      <section className={"container"}>
        <div className={styles.eventsHeader}>
          <h1 className="heading">Events & Exhibitions</h1>
          <p className="subheading">
            Discover where you can meet us! Explore our upcoming events and
            exhibitions where Green Rock Creations will be showcasing our finest
            lab-grown diamonds.
          </p>
        </div>
        <div className={styles.eventsList}>
          {EVENTS.map((event) => (
            <div className={styles.eventCard} key={event.id}>
              <span className={styles.boothBadge}>{event.booth}</span>
              <div className={styles.imageWrapper}>
                <img
                  src={event.image}
                  alt={event.name}
                  className={styles.image}
                />
              </div>
              <div className={styles.eventContent}>
                <div className={styles.eventDate}>
                  {formatDateRange(event.dateRange)}
                </div>
                <div className={styles.eventName}>{event.name}</div>
                <div className={styles.eventMeta}>
                  <span className={styles.eventVenue}>
                    <FiMapPin /> {event.venue}
                  </span>
                </div>

                <div className={styles.eventDescription}>
                  {event.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Events;
